<template>
  <div v-if="template">
    <label v-if="!hideLabel">{{ label }}</label>
    <p class="description" v-if="description">
      <span v-html="description"></span>
    </p>
    <div class="buttons-container">
      <button
        v-if="isSigned"
        class="mylisting-button dark-button"
        @click="
          getUserWithDependentInfo();
          isShowSigningDialog = true;
        "
      >
        View
      </button>
      <button
        v-else
        class="mylisting-button dark-button"
        @click="
          getUserWithDependentInfo();
          isShowSigningDialog = true;
        "
      >
        Sign
      </button>
    </div>
    <SigningDocumentDialog
      v-model="isShowSigningDialog"
      :template="template"
      :user="userWithDependentInfo"
      :fields="fields"
      :fieldsLabels="template.fields"
      :signatures="signatures"
      :isSentRequest="false"
      @signed="handleSignDocument($event)"
    />
    <p class="required-message" v-if="!isSigned && submitClicked">
      Please sign the document
    </p>
  </div>
</template>

<script>
/* This component is used for sign a document
 */

import SigningDocumentDialog from "./SigningDocumentDialog";
import { MAP_DIALOG_SECTION } from "../../../constants/field-types";

export default {
  name: "SigningDocument",
  props: {
    label: String,
    name: String,
    // Remark or description of the section
    description: String,
    // id of document template
    id: Number,
    template: {
      type: Object,
      default: () => {},
    },
    submitClicked: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    mapDependentObjects: Object,
    mapDependentLabelName: Object,
    listOriginal: Array,
  },
  components: {
    SigningDocumentDialog,
  },
  data() {
    return {
      isShowSigningDialog: false,
      isSigned: false,
      fields: [],
      signatures: [],
      userWithDependentInfo: {},
    };
  },
  watch: {
    listOriginal: {
      handler(val) {
        if (val && val.length && this.id) {
          const document = val.find(
            (document) => document.template === this.id
          );
          if (document && document.status === "Signed") {
            this.handleSignDocument(document);
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleSignDocument(data) {
      this.isSigned = true;
      this.signatures = data.signers;
      this.fields = data.fields;
      this.template.status = "Signed";
      this.$emit("signed", data);
    },
    getUserWithDependentInfo() {
      const result = { ...this.user };
      // Dependent data: Experience, Children, Pet, Reference, Contact, Education
      for (const dependentName in this.mapDependentObjects) {
        if (!this.mapDependentLabelName[dependentName]) {
          continue;
        }
        const apiKey = this.tryGet(
          () =>
            MAP_DIALOG_SECTION[this.mapDependentLabelName[dependentName]].apiKey
        );
        const listDependentObjects = this.mapDependentObjects[dependentName];
        if (!listDependentObjects) {
          continue;
        }
        // Use a cloned variable to avoid reference variable
        const listDependentObjectRequests = [];
        for (const dependentObject of listDependentObjects) {
          const clonedObject = { ...dependentObject };
          delete clonedObject.id;
          clonedObject.type = dependentName;
          listDependentObjectRequests.push(clonedObject);
        }
        if (result[apiKey]) {
          result[apiKey] = [...result[apiKey], ...listDependentObjectRequests];
        } else {
          result[apiKey] = listDependentObjectRequests;
        }
      }
      this.userWithDependentInfo = result;
    },
  },
};
</script>
<style scoped>
button:disabled {
  cursor: not-allowed;
  color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/common/documents/SigningDocument.vue